export default class Descuento {
  /** @type {number|null} */ descuento = null
  /** @type {number|null} */ cuota = null
}
